import { render, staticRenderFns } from "./settingWhite.vue?vue&type=template&id=fc65a006&"
import script from "./settingWhite.vue?vue&type=script&lang=ts&"
export * from "./settingWhite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports